import { ComparableDetailCard } from "./ComparableDetailCard";

export interface ComparablePriceCardProps {
  title: string;
  mainData: string | null | undefined | number;
  auxiliaryData: string | null | undefined | number;
  auxiliaryDataSubordinate: string | null | undefined;
  tooltip: string;
  disabled?: boolean;
  onClick?: () => void;
}

export const ComparablePriceCard = ({
  title,
  tooltip,
  mainData,
  auxiliaryData,
  auxiliaryDataSubordinate,
  disabled = false,
  onClick,
}: ComparablePriceCardProps) => {
  return (
    <ComparableDetailCard disabled={disabled} title={title} tooltip={tooltip} size="md" onClick={onClick}>
      <div className="flex flex-col items-start justify-between gap-y-1">
        <div className="flex flex-row items-start justify-between gap-2">
          <span className="text-xl font-medium text-blue-grey-950">{mainData}</span>
        </div>
        <div className="flex flex-row items-center justify-between w-full gap-2">
          <div className={"flex flex-row items-center justify-start gap-1 text-xs font-medium text-blue-grey-600a"}>
            {auxiliaryData && <div className="text-xs font-normal text-blue-grey-950">{auxiliaryData}</div>}
            {auxiliaryDataSubordinate && (
              <div className="text-xs font-normal text-blue-grey-600a">{auxiliaryDataSubordinate}</div>
            )}
          </div>
        </div>
      </div>
    </ComparableDetailCard>
  );
};
